import { ReactNode } from 'react';
import { combineClasses } from '@shared/utils';
import { BrandIcon } from '@shared/ui';
interface HeaderProps {
  logo: {
    src: {
      lightMode: string;
      darkMode?: string;
    };
    alt: string;
    width: number;
    height: number;
  };
  href: string;
  className?: string;
  classCustom?: string;
  centerSlot?: {
    element: ReactNode;
    className?: string;
  };
  endSlot?: {
    element: ReactNode;
    className?: string;
  };
}
export const Header = ({
  logo,
  href,
  className,
  classCustom,
  centerSlot,
  endSlot
}: HeaderProps) => {
  const {
    src,
    alt,
    width,
    height
  } = logo;
  return <header id="header-container" data-testid="header-container" className={combineClasses('sticky bg-neutral-500 text-xs lg:text-lg top-0 left-0 w-full lg:full z-40', className)} data-sentry-component="Header" data-sentry-source-file="index.tsx">
      <div className={combineClasses('flex justify-between items-center', 'w-full mx-auto', classCustom)}>
        <div className={combineClasses('flex items-center justify-start', 'w-nav-bar-xs md:w-nav-bar-sm min-h-14')}>
          <BrandIcon alt={alt} src={src} href={href} width={width} height={height} data-sentry-element="BrandIcon" data-sentry-source-file="index.tsx" />
        </div>

        <div className={combineClasses(centerSlot?.className)}>
          {centerSlot && centerSlot.element}
        </div>

        <div className={combineClasses(endSlot?.className)}>
          {endSlot && endSlot.element}
        </div>
      </div>
    </header>;
};